// import React from "react";
// import "./style.scss";

// const Message = ({ className }) => {
//   return (
   
//     <div style={{ display: "flex", justifyContent: "center" }}>
//     <div className={`message ${className}`}>
//       <p className="text-wrapper-55">The Ultimate Trading Card Markeplace</p>
//    </div>
   
//    </div>
//   );
// };
// export default Message;


import React from "react";
import "./style.scss";

/**
 * A small pill/badge used under the hero heading.
 * Centers itself naturally—no absolute positioning or inline styles.
 */
const Message = ({ className = "",icon = null, t }) => {
  return (
    <div className={`message ${className}`} role="note">
      {icon && <span className="message__icon" aria-hidden="true">{icon}</span>}
    
      <p className="message__text">{t('Your Hockey & Pokémon Card Hub')}</p>
    </div>
  );
};

export default Message;
